import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import baseUrl from "../../baseUrl";
import Spinner from "../../Components/Spinner/Spinner";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { parseJwt } from "../../utils/parseJwt";

const OtherUserProfile = () => {
  const token = JSON.parse(localStorage.getItem("WM:user-token"));
  const [userInfo, setUserInfo] = useState({});
  const [following, setFollowing] = useState([]);
  const [avatar, setAvatar] = useState("");
  const [loading, setLoading] = useState(false);

  const { id } = useParams();

  useEffect(() => {
    setLoading(true);

    axios
      .post(
        `${baseUrl}/user/other-user-profile`,
        { id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          setAvatar(res.data.user.avatar["url"]);
          setUserInfo(res.data.user);
          setFollowing(res.data.user.following);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token, id]);

  const handleFollowAction = () => {
    setLoading(true);
    axios
      .post(
        `${baseUrl}/user/follow-user`,
        { id, userId: parseJwt(token).id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        toast.success(res.data.message);
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };
  const handleUnFollowAction = () => {
    setLoading(true);
    axios
      .post(
        `${baseUrl}/user/unfollow-user`,
        { id, userId: parseJwt(token).id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        toast.success(res.data.message);
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading && <Spinner />}
      <div className="h-full mt-5">
        <span className="text-2xl ml-5 font-semibold block">
          {userInfo.fullName} Profile
        </span>
        <div className="border-b-2 block md:flex">
          <div className="w-full md:w-2/5 div-4 sm:div-6 lg:div-8 bg-white shadow-md">
            <div className="flex justify-between"></div>
            <div className="w-full div-8 mx-2 flex mb-4 justify-center">
              <img
                id="showImage"
                className="items-center border"
                style={{
                  borderRadius: "50%",
                  width: "400px",
                  height: "400px",
                }}
                src={avatar}
                alt="user_pic"
              />
            </div>
            {userInfo._id !== parseJwt(token).id && (
              <div>
                {following.includes(parseJwt(token).id) ? (
                  <button
                    onClick={handleUnFollowAction}
                    className="-mt-2 text-md  font-bold text-white bg-red-700 rounded-full px-5 ml-5 mr-3 py-2 hover:bg-green-800"
                  >
                    Unfollow
                  </button>
                ) : (
                  <button
                    onClick={handleFollowAction}
                    className="-mt-2 text-md  font-bold text-white bg-green-700 rounded-full px-5 ml-5 mr-3 py-2 hover:bg-green-800"
                  >
                    Follow
                  </button>
                )}
              </div>
            )}
          </div>
          <div className="w-full md:w-3/5 div-8 bg-white lg:ml-4 shadow-md">
            <div className="rounded shadow div-6">
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Full Name
                </label>
                <div className="flex">
                  <div className="border-1 rounded-r px-4 py-2 w-full">
                    {userInfo.fullName}
                  </div>
                </div>
              </div>
              <div className="pb-4">
                <label
                  htmlFor="about"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Email
                </label>
                <div className="border-1 rounded-r px-4 py-2 w-full">
                  {userInfo.email}
                </div>
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Phone Number
                </label>
                <div className="flex">
                  <div className="border-1 rounded-r px-4 py-2 w-full">
                    +977-{userInfo.phoneNumber}
                  </div>
                </div>
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Address
                </label>
                <div className="flex">
                  <div className="border-1 rounded-r px-4 py-2 w-full">
                    {userInfo.address}
                  </div>
                </div>
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Date of Birth
                </label>
                <div className="flex">
                  <div className="border-1 rounded-r px-4 py-2 w-full">
                    {moment(userInfo.dob).format("MMMM Do YYYY")}
                  </div>
                </div>
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Gender
                </label>
                <div className="flex">
                  <div className="border-1 rounded-r px-4 py-2 w-full">
                    {userInfo.gender}
                  </div>
                </div>
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Verified
                </label>
                <div className="flex">
                  <div className="border-1 rounded-r px-4 py-2 w-full">
                    {userInfo.emailVerified ? "Yes" : "No"}
                  </div>
                </div>
              </div>
              <div className="pb-6">
                <label
                  htmlFor="name"
                  className="font-semibold text-gray-700 block pb-1"
                >
                  Profile Created At
                </label>
                <div className="flex">
                  <div className="border-1 rounded-r px-4 py-2 w-full">
                    {moment(userInfo.createdAt).fromNow()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtherUserProfile;
